export function Title({ title }) {
  return <h3 className="text-3xl font-semibold text-theme-1">{title}</h3>;
}
